import { IOrderInfo, IOrderItem, ISolvePrescriptions, PrescriptionType } from 'src/entity/OrderEntity';
import { UtilPrint } from 'src/utils/print';
import { UtilDateTime } from 'src/utils/datetime';
import OrderService from './OrderService';
import { MallMedicineType } from './MallService';
import { EnumDiseaseType, EnumMedicineCategory, EnumMedicineType } from 'src/constants/enum';
import MedicineService from './MedicineService';
import { GAO_FANG } from 'src/constants/Gaofang';
import { getMethodDes } from 'src/redux/actions/userCreator';
import { CATEGORY_ORIGINAL } from 'src/constants/Order';

interface IOrderItemPair {
  left: IOrderItem;
  right?: IOrderItem;
  solveIndex?: number;
  group?: string;
  /** 剂数 */
  amount: number;
  preInfo: ISolvePrescriptions;
}

// export const TakeMethods: { [p in number]: string } = {
//   1: '同煎',
//   2: '先煎',
//   3: '后下',
//   4: '包煎',
//   5: '烊化',
//   6: '外用',
//   7: '研粉另服',
//   8: '研粉入丸散',
//   9: '冲服',
//   10: '泡水代茶饮',
//   11: '另煎',
// };

interface GaoFang {
  name: string;
  uuid: string;
  medicines: Array<{
    name: string;
    weight: number;
  }>;
}

/** 药品清单打印 */
interface IMedicinePrintData {
  groupName: string;
  items: IOrderItem[];
  showGroup: boolean;
}

class OrderPrintService {
  private gaofang = new Map<string, string>();
  /** 中药加工方式 */
  takeMethods: { [p in number]: string } = {};

  public async printOrderList(orderInfo: IOrderInfo) {
    if (orderInfo.category === CATEGORY_ORIGINAL) {
      return this.printOrderMedicineList(orderInfo);
    } else {
      await this.fetchTakeMethods();
      return this.printPrescriptionList(orderInfo);
    }
  }

  /** 获取中药加工方式 */
  public async fetchTakeMethods(): Promise<{ [p in number]: string }> {
    const list = await MedicineService.fetchTakeMethods(1);
    if (list && list.length) {
      this.takeMethods = {};
      list.forEach(item => {
        this.takeMethods[item.id] = item.name;
      })
    }
    return this.takeMethods;
  }

  public handleSpecificationUnit(orderItem: IOrderItem): string {
    const { specification, take_unit, retail_unit } = orderItem;
    let str = '';
    if (!specification) {
      str = '散装';
    } else {
      str = `${specification}${take_unit}/${retail_unit}`;
    }

    return str;
  }

  /** 打印药品清单，需过滤掉退款药品和退款数量 */
  public printOrderMedicineList(orderInfo: IOrderInfo) {
    const style =
      '@page{size:A4 portrait}body{padding:0;margin:0}hr{margin:16px 0}.page{width:100%;min-height:100vh;position:relative;display:flex;flex-direction:column}.page .watermark{position:absolute;white-space:nowrap;font-size:140px;letter-spacing:10px;color:black;opacity:.1;left:50%;top:50%;transform:translate(-50%,-50%)}.table-box{width:100%}.table-box .table{border-collapse:collapse;border-spacing:0;font-size:1rem;width:100%}.table-box .table:not(:first-child){margin-top:10px}.table-box .table .divider{border-top:1px dashed gray}.table-box .table th,.table-box .table td{text-align:left;height:40px}.table-box .table th.copy-fist-th,.table-box .table td.copy-fist-th{border-left:1px dashed gray;padding-left:20px}.header{display:flex;justify-content:space-between;font-size:.875rem}.text-area{display:flex;flex-wrap:wrap;margin-bottom:-12px}.text-area span{flex:0 33.33%;margin-bottom:12px}.text-area .underline{flex:0 calc(33.33% - 24px);padding-bottom:12px;margin-bottom:16px;margin-right:24px;font-size:1.25rem;border-bottom:1px solid gray}.foot{font-size:.875rem;margin-top:auto}.foot .number{text-align:right;margin-bottom:0;font-size:.75rem}.page.client .gross,.page.client .header .right,.page.client .watermark,.page.client>.foot .bottom{display:none}.group-name{color: rgba(34, 34, 34, 1);font-family: Microsoft YaHei;font-weight: bold;font-size: 16px;line-height: 27px;margin-bottom: 16px;}.dash-line {width: 100%;height: 1px;border-top: 1px dashed rgba(204, 204, 204, 1);}';

    const date = UtilDateTime.datetimeFormat('yyyy-MM-dd', new Date(orderInfo.created_time));
    const receiverInfo = `${orderInfo.receiver_name} ${UtilPrint.hideMobile(orderInfo.receiver_mobile)} ${this.intantStructureAddress(
      orderInfo.receiver_structure_address
    )}`;

    const pages: IMedicinePrintData[] = [];

    // const createPage = (items: IOrderItem[], page: number, totalPage: number) => {
    //   // 打印药品清单 中的 规格字段 需要取 批发单位  wholesale_unit
    //   return `
    //     <div class="watermark">商家联</div>
    //     <div class="header">
    //       <span class="left">日期：${date} </span>
    //       <span class="right">订单号：${orderInfo.out_trade_no}</span>
    //       <span class="one_line">医疗机构：${orderInfo.institution_name} </span>
    //     </div>
    //     <hr/>
    //     <div class="table-box">
    //       <table class="table">
    //         <thead>
    //           <tr>
    //               <th>药品清单：</th>
    //               <th>药品（当量）</th>
    //               <th>剂型</th>
    //               <th>品牌</th>
    //               <th>装量</th>
    //               <th>数量</th>
    //           </tr>
    //         </thead>
    //         <tbody>${items.map(item => `<tr>
    //             <td></td>
    //             <td>${item.short_name}${item.dosage_form === 0 ? '' : `（${item.equivalent}克）`}</td>
    //             <td>${MallMedicineType.find(t => t.value === item.dosage_form)?.name}</td>
    //             <td>${item.brand_name}</td>
    //             <td>${this.handleSpecificationUnit(item)}</td>
    //             <td>${item.quantity}${item.wholesale_unit || ''}</td>
    //           </tr>`).join('')}
    //         </tbody>
    //       </table>
    //     </div>
    //     <div class="foot">
    //         <hr/>
    //         <p class="top two_line">收货信息：${receiverInfo}</p>
    //         ${orderInfo.doctor_remarks ? `<p class="bottom two_line">医生备注：${orderInfo.doctor_remarks}</p>` : ''}
    //         <p class="number">第${page}页，共${totalPage}页</p>
    //     </div>`
    // };

    const createPage = (pageData: IMedicinePrintData, page: number, totalPage: number) => {
      let isCpmMed = false;
      try {
        const sku = pageData.items[0];
        isCpmMed = sku.type === EnumMedicineCategory.中成药;
      } catch (error) {
        console.error(error);
      }
      const head = isCpmMed
        ? `<th>药品名称</th>
      <th>剂型</th>
      <th>品牌</th>
      <th>包装</th>
      <th>实发数量</th>`
        : `<th>药品（当量）</th>
        <th>剂型</th>
        <th>品牌</th>
        <th>装量</th>
        <th>实发数量</th>`;

      const body = isCpmMed
        ? pageData.items
          .map(
            (item) => `<tr>
        <td>${item.name || ''}</td>
        <td>${item.west_dosage_form || ''}</td>
        <td>${item.brand_name || ''}</td>
        <td>${item.package || ''}</td>
        <td>${item.practical_quantity}${item.wholesale_unit || ''}</td>
      </tr>`
          )
          .join('')
        : pageData.items
          .map(
            (item) => `<tr>
        <td>${item.short_name}${item.dosage_form === 0 ? '' : `（${item.equivalent}克）`}</td>
        <td>${MallMedicineType.find((t) => t.value === item.dosage_form)?.name || ''}</td>
        <td>${item.brand_name || ''}</td>
        <td>${this.handleSpecificationUnit(item)}</td>
        <td>${item.practical_quantity}${item.wholesale_unit || ''}</td>
      </tr>`
          )
          .join('');

      // 打印药品清单 中的 规格字段 需要取 批发单位  wholesale_unit
      return `
        <div class="watermark">商家联</div>
        <div class="header">
          <span class="left">日期：${date} </span>
          <span class="right">订单号：${orderInfo.out_trade_no}</span>
          <span class="one_line">医疗机构：${orderInfo.institution_name} </span>
        </div>
        <hr/>
        ${pageData.showGroup ? `<div class="group-name">${pageData.groupName}</div><div class="dash-line"></div>` : ''}
        <div class="table-box">
          <table class="table">
            <thead>
              <tr>
                 ${head}
              </tr>
            </thead>
            <tbody>${body}
            </tbody>
          </table>
        </div>
        <div class="foot">
            <hr/>
            <p class="top two_line">收货信息：${receiverInfo}</p>
            ${orderInfo.doctor_remarks ? `<p class="bottom two_line">医生备注：${orderInfo.doctor_remarks}</p>` : ''}
            <p class="number">第${page}页，共${totalPage}页</p>
        </div>`;
    };

    const createPages = () => {
      let html = '';
      let clientHtml = '';
      // const rowsPerPage = 20;
      // const totalPages = Math.ceil(orderInfo.items.length / rowsPerPage);

      // let page = 1;
      // for (let i = 0; i < orderInfo.items.length; i += rowsPerPage) {
      //   const slice = orderInfo.items.slice(i, i + rowsPerPage);
      //   const pageHtml = createPage(slice, page, totalPages);
      //   page++;
      //   html += '<div class="page">' + pageHtml + "</div>";
      //   clientHtml += '<div class="page client">' + pageHtml + "</div>";
      // }

      const medicineMap = new Map<string, IOrderItem[]>();
      for (const item of orderInfo.items || []) {
        // 过滤掉退款药品
        if (!item.is_all_refund || item.practical_quantity > 0) {
          if (medicineMap.has(item.medicine_group_name)) {
            const tempItems = medicineMap.get(item.medicine_group_name) || [];
            tempItems.push(item);
          } else {
            medicineMap.set(item.medicine_group_name, [item]);
          }
        }
      }

      medicineMap.forEach((value: IOrderItem[], key: string) => {
        let rowsPerPage = 19;
        for (let i = 0; i < value.length; i += rowsPerPage) {
          pages.push({
            groupName: key,
            items: value.slice(i, i + rowsPerPage),
            showGroup: i === 0,
          });
          if (i > 0) {
            rowsPerPage = 20;
          }
        }
      });

      for (let i = 0; i < pages.length; i++) {
        const pageHtml = createPage(pages[i], i + 1, pages.length);
        html += '<div class="page">' + pageHtml + '</div>';
        clientHtml += '<div class="page client">' + pageHtml + '</div>';
      }

      return html + clientHtml;
    };

    UtilPrint.printRawHtml(`<html><head><title>打印清单</title><head><body><div>${createPages()}</div></body></html>`, style);
    return true;
  }

  /** 打印处方订单 */
  public printPrescriptionList(orderInfo: IOrderInfo) {
    const snapshot = orderInfo.e_prescription_snapshot;
    console.log(snapshot);
    if (!snapshot) {
      return false;
    }

    this.initGaofang();

    const style = `@page{size:A4 portrait;}body{padding:0;margin:0;}hr{margin:16px 0;}.one_line {display: block;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;flex: 0 auto !important;}.two_line {overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;}.page{width:100%;min-height:100vh;position:relative;display:flex;flex-direction:column;page-break-after:always;}.page .watermark{position:absolute;white-space:nowrap;font-size:140px;letter-spacing:10px;color:black;opacity:0.1;left:50%;top:50%;transform:translate(-50%,-50%);}.table-box{width:100%;}.table-box .table{border-collapse:collapse;border-spacing:0;font-size:1rem;width:100%;}.table-box .table:not(:first-child){margin-top:10px;}.table-box .table .divider{border-top:1px dashed gray;}.table-box .table th,.table-box .table td{text-align:left;height:40px;}.table-box .table th.copy-fist-th,.table-box .table td.copy-fist-th{border-left:1px dashed gray;padding-left:20px;}.special.table tr th:first-child{white-space:nowrap;width:60px;}.special.table tr td{padding:12px 0 0;}.special.table tr td:first-child{vertical-align:top;}.header{display:flex;justify-content:space-between;font-size:0.875rem;}.text-area{display:flex;flex-wrap:wrap;margin-bottom:-12px;}.text-area span{flex:0 33.33%;margin-bottom:12px;}.text-area .underline{flex:0 calc(33.33% - 24px);padding-bottom:12px;margin-bottom:16px;margin-right:24px;font-size:1.25rem;border-bottom:1px solid gray;}.foot{font-size:0.875rem;margin-top:auto;}.foot .number{text-align:right;margin-bottom:0;font-size:0.75rem;}.page.client .gross,.page.client .header .right,.page.client .watermark,.page.client>.foot .bottom{display:none;} `;

    const date = UtilDateTime.datetimeFormat('yyyy-MM-dd', new Date(orderInfo.created_time));
    const receiverInfo = `${orderInfo.receiver_name} ${UtilPrint.hideMobile(orderInfo.receiver_mobile)} ${this.intantStructureAddress(
      orderInfo.receiver_structure_address
    )}`;

    const toGender = (gender: string | null) => {
      const map: any = { F: '女', M: '男' };
      return map[gender || ''] || '';
    };

    const createRow = (left: boolean, item: IOrderItem | undefined, amount: number) => {
      const className = left ? '' : 'class="copy-fist-th"';
      const takeMethod = item && item.take_method_id ? this.takeMethods[item.take_method_id] : undefined;
      const sup = takeMethod ? `<sup>${'&nbsp;' + takeMethod}</sup>` : '';
      const group = item ? snapshot.solve_prescriptions[item.group] : undefined;
      const prescItem = group && item ? group.presc_items.find((i) => i.sku === item.medicine_sku) : undefined;
      const perDose = prescItem ? prescItem.pharmacy_quantity : item ? item.quantity / amount : 0;
      // console.log('dosage_form:', item?.dosage_form)
      return item
        ? `<td ${className}>${item.short_name}${item.dosage_form !== 0 ? `（${item.equivalent}克）` : ''} ${sup}</td>
      <td>${Number(perDose.toFixed(2))}${item.retail_unit}</td>
      <td class="gross">${item.quantity}${item.retail_unit}</td>`
        : '<td class="copy-fist-th"></td><td></td><td></td>';
    };

    const createCpmRow = (item: IOrderItem | undefined) => {
      return item ? `<td>${item.name}</td><td>${item.quantity}</td><td>${item.west_usage}</td>` : `<td></td><td></td><td></td>`;
    };

    /** 膏方foot  没有 preInfo */
    const createTableFoot = (solveIndex: number | undefined, preInfo?: ISolvePrescriptions) => {
      let sp = snapshot.solve_prescriptions[solveIndex || 0];
      if (preInfo) {
        sp = preInfo;
      }
      const method = getMethodDes(sp.processing_method);
      return `<div class="foot">
        <p class="top one_line">剂数：${sp.prescription_amount}剂（每剂分${sp.use_times || 1}次服用，共${sp.use_times * sp.prescription_amount}服）</p>
        ${method ? '<p class="top one_line">加工：' + method + '</p>' : ''}
        <p class="bottom two_line">用法：${sp.prescription_approach}${sp.taking_method ? '，' + sp.taking_method : ''}</p>
      </div>`;
    };
    const createTable = (pair: IOrderItemPair[]) => {
      const solveIndex = pair.length > 0 ? pair[0].solveIndex : undefined;
      const pre = pair.length > 0 ? pair[0].preInfo : undefined;
      let createContent = '';
      if (pre && pre.type === EnumMedicineCategory.中成药) {
        createContent = `<table class="table">
        <thead>
          <tr>
              <th>药品</th>
              <th>数量</th>
              <th>用法用量</th>
          </tr>
        </thead>
        <tbody>
        ${pair.map((p, index) => {
          let content = '';
          if (p.left) {
            content += `<tr ${index === 0 ? 'class="divider"' : ''}>${createCpmRow(p.left)}</tr>`;
          }
          if (p.right) {
            content += `<tr ${index === 0 && !p.left ? 'class="divider"' : ''}>${createCpmRow(p.right)}</tr>`;
          }
          return content;
        })}
        </tbody>
      </table>`;
      } else {
        createContent =
          `<table class="table">
        <thead>
          <tr>
              <th>处方${solveIndex != null ? solveIndex + 1 : ''}</th>
              <th>药品（当量）</th>
              <th>每剂量</th>
              <th class="gross">总量</th>
              <th class="copy-fist-th">药品（当量）</th>
              <th>每剂量</th>
              <th class="gross">总量</th>
          </tr>
        </thead>
        <tbody>${pair
            .map(
              (p) => `<tr ${p.group ? 'class="divider"' : ''}>
            <td>${p.group || ''}</td>
            ${createRow(true, p.left, p.amount)}
            ${createRow(false, p.right, p.amount)}
          </tr>`
            )
            .join('')}
        </tbody>
      </table>` + createTableFoot(solveIndex, pre);
      }
      return createContent;
    };

    const createGaofangTable = (gaofangItems: IOrderItem[]) => {
      if (gaofangItems.length === 0) {
        return '';
      }

      let itemHtml = '';
      let solveIndex = 0;
      gaofangItems.forEach((item, index) => {
        if (index === 0) {
          itemHtml += '<tr class="divider"><td>膏方</td>';
        } else {
          itemHtml += '<tr><td></td>';
        }
        itemHtml += '<td>';
        solveIndex = item.group || 0;
        const sp = snapshot.solve_prescriptions[solveIndex];
        const prescItem = sp.presc_items.find((i) => i.sku === item.medicine_sku);
        const gf = prescItem && this.gaofang.get(prescItem.tcm_uuid);
        if (gf && prescItem) {
          itemHtml += gf;
          itemHtml += `（${item.name} x ${prescItem.pharmacy_quantity}${item.retail_unit}）`;
        }
        itemHtml += '</td>';

        itemHtml += '</tr>';
      });

      return (
        `<table class="table special">
        <thead>
          <tr>
              <th>处方${solveIndex != null ? solveIndex + 1 : ''}</th>
              <th></th>
          </tr>
        </thead>
        <tbody>
          ${itemHtml}
        </tbody>
      </table>` + createTableFoot(solveIndex)
      );
    };

    const createPage = (tableHtml: string, pageIndex: number, totalPages: number) => {
      const doctors = [orderInfo.doctor_name || ''];
      if (snapshot.cooperative_diagnosis) {
        doctors.push(snapshot.cooperative_diagnosis.doctor_name);
      }
      const disease = (snapshot.general_diseases || []).filter(obj => {
        return obj.type === EnumDiseaseType.GB && !!obj.uuid
      }).map(obj => obj.name).join('，');
      return `
        <div class="watermark">商家联</div>
        <div class="header">
          <span class="left">日期：${date} </span>
          <span class="right">订单号：${orderInfo.out_trade_no}</span>
          <span class="one_line">医疗机构：${orderInfo.institution_name} </span>
        </div>
        <hr/>
        <div class="text-area">
          <span>姓名：${snapshot.patient_name}</span>
          <span>性别：${toGender(snapshot.patient_gender)}</span>
          <span>年龄：${snapshot.patient_age || ''}岁</span>
          <span class="two_line">诊断：${disease || ''}</span>
          <span class="two_line">证型：${snapshot.syndrome_type || ''}</span>
        </div>
        <hr/>
        <div class="table-box">
          ${tableHtml}
        </div>
        <div class="foot">
          <hr/>
          <div class="text-area">
              <span>医生签名：</span>
              <span>审核签名：</span>
              <span>调配、核对、发药签名</span>
              <span class="underline">${doctors.join('/')}</span>
              <span class="underline"></span>
              <span class="underline"></span>
          </div>
          <p class="top two_line">收货信息：${receiverInfo}</p>
          ${orderInfo.doctor_remarks ? `<p class="bottom two_line">医生备注：${orderInfo.doctor_remarks}</p>` : ''}
          <p class="number">第${pageIndex}页，共${totalPages}页</p>
        </div>`;
    };

    const makePairs = (sp: ISolvePrescriptions, solveIndex: number) => {
      const pair: IOrderItemPair[] = [];
      let onePair: IOrderItemPair | undefined;
      const amount = sp.prescription_amount;

      const makeOnePair = (item: IOrderItem, i: number) => {
        const find = (sp.presc_items || []).find(sku => sku.sku === item.medicine_sku);
        // console.log(item, find);
        if (find) {
          item.take_method_id = find.take_method_id || null;
        }
        if (i % 2 === 0) {
          onePair = { left: item, amount, preInfo: sp };
          if (sp.type === EnumMedicineCategory.中药) {
            onePair.group = MedicineService.getMedicineType(item.dosage_form);
          }
          onePair.solveIndex = solveIndex;
          pair.push(onePair);
        } else if (onePair) {
          onePair.right = item;
        }
      };

      const typedItems = new Map<EnumMedicineType, IOrderItem[]>();
      for (const item of orderInfo.items) {
        if (item.group !== solveIndex) {
          continue;
        }

        const group = typedItems.get(item.dosage_form);
        if (group) {
          group.push(item);
        } else {
          typedItems.set(item.dosage_form, [item]);
        }
      }

      const types = Array.from(typedItems.keys()).sort();
      types.forEach((type) => {
        const group = typedItems.get(type);
        if (group) {
          group.forEach((item, i) => makeOnePair(item, i));
        }
      });

      return pair;
    };

    // 删除重复的title和group
    const removeDuplicated = (pair: IOrderItemPair[]) => {
      for (let i = pair.length - 1; i > 0; i--) {
        if (pair[i].group === pair[i - 1].group) {
          pair[i].group = undefined;
        }
      }
    };

    // 是否打印客户联，默认打印
    const printClient = orderInfo.is_provide_prescription !== false;

    const createPages = () => {
      let html = '';
      let clientHtml = '';
      const rowsPerPage = 14;
      let totalPage = 0;
      // console.log(orderInfo.items);

      // 膏方暂时隐藏
      // const gaofangItems: IOrderItem[] = [];
      // for (const item of orderInfo.items) {
      //   const sp = snapshot.solve_prescriptions[item.group || 0];
      //   const prescItem = sp.presc_items.find(i => i.sku === item.medicine_sku);
      //   if (prescItem && this.gaofang.has(prescItem.tcm_uuid)) {
      //     gaofangItems.push(item);
      //   }
      // }

      // if (gaofangItems.length > 0) {
      //   let specialTable = createGaofangTable(gaofangItems.filter(i => i.group === 0));
      //   specialTable += createGaofangTable(gaofangItems.filter(i => i.group === 1));
      //   specialTable += createGaofangTable(gaofangItems.filter(i => i.group === 2));
      //   const pageHtml = createPage(specialTable, 1, 1);
      //   html += '<div class="page">' + pageHtml + "</div>";
      //   if (printClient) {
      //     clientHtml += '<div class="page client">' + pageHtml + "</div>";
      //   }
      // } else {
      const solvePairs: IOrderItemPair[][] = [];
      let maxIndex = 0;
      const tcmPre = snapshot.solve_prescriptions.filter((item) => item.type === EnumMedicineCategory.中药);
      const cpmPre = snapshot.solve_prescriptions.filter((item) => item.type === EnumMedicineCategory.中成药);
      const allPre = tcmPre.concat(cpmPre);
      for (let solveIndex = 0; solveIndex < allPre.length; solveIndex++) {
        const pair = makePairs(allPre[solveIndex], solveIndex);
        if (pair.length > 0) {
          maxIndex = solveIndex;
          totalPage += Math.ceil(pair.length / rowsPerPage);
          solvePairs.push(pair);
        }
      }
      if (maxIndex === 0) {
        solvePairs.forEach((pairs) => pairs.forEach((pair) => (pair.solveIndex = undefined)));
      }
      let pageIndex = 1;
      for (const pair of solvePairs) {
        for (let i = 0; i < pair.length; i += rowsPerPage) {
          const slice = pair.slice(i, i + rowsPerPage);
          removeDuplicated(slice);
          const tableHtml = createTable(slice);
          const pageHtml = createPage(tableHtml, pageIndex, totalPage);
          pageIndex++;
          html += '<div class="page">' + pageHtml + '</div>';
          if (printClient) {
            clientHtml += '<div class="page client">' + pageHtml + '</div>';
          }
        }
      }
      // }

      return html + clientHtml;
    };

    UtilPrint.printRawHtml(`<body><div>${createPages()}</div></body>`, style);
    return true;
  }

  /** 打印运单 */
  public printExpressPage(rawHtml: string) {
    // 去除不能加载的image元素
    const printDocument = new DOMParser().parseFromString(rawHtml, 'text/html');
    const images = printDocument.getElementsByTagName('img');
    for (const img of Array.from(images)) {
      const src = img.getAttribute('src');
      if (!src || !src.startsWith('data:image')) {
        img.remove();
      }
    }

    UtilPrint.printRawHtml(printDocument.documentElement.innerHTML, '');
  }

  /** 打印顺丰运单 */
  async printExpressPageSF(blob: Blob): Promise<void> {
    const printData = await UtilPrint.blob2Base64(blob);
    if (!!printData) {
      UtilPrint.printPdf(printData, true);
    }
  }

  private intantStructureAddress(area: number | string): string {
    const areaNumber = Number(area);
    if (areaNumber > 0) {
      const location = OrderService.instantLocationArea(areaNumber);
      if (location) {
        return location.full_name;
      }
    }

    return '';
  }

  private initGaofang() {
    if (this.gaofang.size > 0) {
      return;
    }

    try {
      const objs: GaoFang[] = JSON.parse(GAO_FANG);
      objs.forEach((obj) => {
        const str = obj.medicines.map((i) => `${i.name} ${i.weight}克`).join('，');
        this.gaofang.set(obj.uuid, str);
      });
    } catch (err) {
      console.error(err);
    }
  }
}

export default new OrderPrintService();



// WEBPACK FOOTER //
// ./src/services/OrderPrintService.ts